import React from 'react';
import { ScrollReveal } from './shared';

const WhyApigSection = () => {
  const reasons = [
    {
      number: '01',
      title: 'Integrated Model',
      description: 'APIG connects intelligence, positioning, and execution in one advisory model. No handoffs, no gaps.',
    },
    {
      number: '02',
      title: 'Senior Operating Perspective',
      description: 'Leadership experience spans predictive analytics, enterprise transformation, board-level strategy, and execution support.',
    },
    {
      number: '03',
      title: 'Outcomes That Tie Back to Decisions',
      description: 'The work links evidence to adoption, retention, customer engagement, and commercial results.',
    },
  ];

  return (
    <section className="section-spacing bg-white" data-testid="why-apig-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center mb-16">
            <p className="overline mb-4">What Differentiates APIG</p>
            <h2 className="heading-section text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="why-apig-headline">
              Evidence-Based Outcomes. Senior-Led. Integrated.
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {reasons.map((reason, index) => (
            <ScrollReveal key={index} delay={index * 150}>
              <div className="text-center" data-testid={`why-apig-${index + 1}`}>
                <span className="text-[#D97706] font-serif text-2xl font-medium block mb-4">{reason.number}</span>
                <h3 className="font-serif text-xl text-[#0B1A2B] mb-3">{reason.title}</h3>
                <p className="text-[#334155] text-[0.9375rem] leading-relaxed">{reason.description}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyApigSection;
